import loginService from '../../services/LoginService';

export async function refreshToken() {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    const response = await loginService.refreshToken(token);
    return response.data.access_token;
  } catch (error) {
    console.log('error on getting new token: ', error);
    return null;
  }
}
